<template>
  <div class="signin">
    <!-- 좌측 다크 패널 -->
    <aside class="signin__left">
      <div class="signin__brand">
        <img :src="pineappleLogo" alt="pineapple" class="signin__brand-logo" />
        <div class="signin__brand-text">
          <div class="signin__brand-name">pineapple</div>
          <div class="signin__brand-sub">{{ $CONF.APP_USERTYPE }}</div>
        </div>
      </div>

      <div class="signin__char">
        <!-- Pine 캐릭터 (DesignSystem/characters-a.jsx 기반) -->
        <svg viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg" class="signin__pine">
          <!-- Leaves -->
          <g>
            <path d="M100 25 Q88 50 92 85 Q100 70 108 85 Q112 50 100 25 Z" fill="#7BB073" />
            <path d="M75 45 Q70 75 88 92 Q85 70 92 55 Q82 45 75 45 Z" fill="#4F8A5C" />
            <path d="M125 45 Q130 75 112 92 Q115 70 108 55 Q118 45 125 45 Z" fill="#4F8A5C" />
            <path d="M62 70 Q66 88 86 95 Q78 82 80 72 Q70 65 62 70 Z" fill="#7BB073" />
            <path d="M138 70 Q134 88 114 95 Q122 82 120 72 Q130 65 138 70 Z" fill="#7BB073" />
          </g>
          <!-- Body -->
          <path
            d="M100 90 C50 90 42 130 42 165 C42 205 65 220 100 220 C135 220 158 205 158 165 C158 130 150 90 100 90 Z"
            fill="#FFC93C"
            stroke="#C98A0A"
            stroke-width="2.5"
          />
          <!-- Quilt pattern -->
          <g opacity="0.35" stroke="#E5A91A" stroke-width="1.5" fill="none">
            <path d="M60 130 L80 120 L100 130 L120 120 L140 130" />
            <path d="M60 130 L80 140 L100 130 L120 140 L140 130" />
            <path d="M60 160 L80 150 L100 160 L120 150 L140 160" />
            <path d="M60 160 L80 170 L100 160 L120 170 L140 160" />
            <path d="M60 190 L80 180 L100 190 L120 180 L140 190" />
          </g>
          <!-- Seeds -->
          <g fill="#E5A91A" opacity="0.55">
            <circle cx="80" cy="130" r="1.5" />
            <circle cx="120" cy="130" r="1.5" />
            <circle cx="100" cy="160" r="1.5" />
            <circle cx="80" cy="190" r="1.5" />
            <circle cx="120" cy="190" r="1.5" />
          </g>
          <!-- Blush -->
          <g fill="#F5B5A8" opacity="0.7">
            <ellipse cx="86" cy="159" rx="6" ry="3.5" />
            <ellipse cx="114" cy="159" rx="6" ry="3.5" />
          </g>
          <!-- Happy eyes (^_^) -->
          <g fill="none" stroke="#1F1A14" stroke-width="3.2" stroke-linecap="round">
            <path d="M83 151 Q88 145 93 151" />
            <path d="M107 151 Q112 145 117 151" />
          </g>
          <!-- Mouth -->
          <path
            d="M94 161 Q100 167 106 161"
            fill="none"
            stroke="#1F1A14"
            stroke-width="2.6"
            stroke-linecap="round"
          />
        </svg>

        <div class="signin__bubble">
          관리자님, 환영합니다!<br />
          오늘도 좋은 하루 되세요
        </div>
      </div>
    </aside>

    <!-- 우측 폼 -->
    <main class="signin__right">
      <div class="signin__form-wrap">
        <span class="signin__chip">FOR {{ $CONF.APP_USERTYPE }}</span>
        <h1 class="signin__title">관리자 로그인</h1>
        <p class="signin__desc">Enter your email and password to Sign In</p>

        <VeeForm :validation-schema="schema" class="signin__form" @submit="onSubmit">
          <Field v-slot="{ field, errors }" name="email">
            <div class="p-field">
              <label class="p-field__label">이메일</label>
              <input
                v-bind="field"
                type="email"
                class="p-input signin__input"
                :class="{ 'is-invalid': errors.length > 0 }"
                placeholder="admin@pineapple.kr"
              />
              <ErrorMessage name="email" class="p-field__error" />
            </div>
          </Field>

          <Field v-slot="{ field, errors }" name="password">
            <div class="p-field">
              <label class="p-field__label">비밀번호</label>
              <input
                v-bind="field"
                type="password"
                class="p-input signin__input"
                :class="{ 'is-invalid': errors.length > 0 }"
                placeholder="••••••••"
              />
              <ErrorMessage name="password" class="p-field__error" />
            </div>
          </Field>

          <button type="submit" class="signin__btn">로그인</button>
        </VeeForm>

        <footer class="signin__foot">
          <p class="signin__copyright">
            Copyright © {{ new Date().getFullYear() }} Soft by Corpuslab inc.
          </p>
        </footer>
      </div>
    </main>
  </div>
</template>

<script>
import { Field, Form as VeeForm, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import pineappleLogo from "@/assets/img/pineapple-logo.png";

export default {
  name: "SigninCover",
  components: { Field, VeeForm, ErrorMessage },
  data() {
    return {
      pineappleLogo,
      schema: yup.object({
        email: yup.string().email("올바른 이메일 형식이어야 합니다").required("이메일을 입력해주세요"),
        password: yup
          .string()
          .min(6, "비밀번호는 6자 이상이어야 합니다")
          .required("비밀번호를 입력해주세요"),
      }),
    };
  },
  methods: {
    onSubmit(values) {
      this.$store.dispatch(this.$CONF.ACT_LOGIN, values);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.signin {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: $p-bg;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }

  // ── 좌측 다크 패널 ──
  &__left {
    background: #1A1612;
    background-image:
      radial-gradient(circle at 30% 20%, rgba(255, 201, 60, 0.06) 0%, transparent 50%),
      radial-gradient(circle at 70% 80%, rgba(255, 201, 60, 0.04) 0%, transparent 50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 28px;
    padding: 48px 60px;
    color: $p-point;
    position: relative;
    font-family: $p-font-body;

    @media (max-width: 900px) {
      display: none;
    }
  }

  &__brand {
    display: flex;
    align-items: center;
    gap: 0;
    margin-bottom: 8px;
  }

  &__brand-logo {
    width: 96px;
    height: 96px;
    object-fit: contain;
    flex-shrink: 0;
  }

  &__brand-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-left: -10px;
  }

  &__brand-name {
    font-size: 32px;
    font-weight: 900;
    letter-spacing: -0.02em;
    color: $p-panel;
    line-height: 1;
  }

  &__brand-sub {
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.24em;
    color: rgba(255, 251, 239, 0.5);
    text-transform: uppercase;
    margin-top: 4px;
  }

  &__char {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 22px;
  }

  &__pine {
    width: 240px;
    height: 288px;
    filter: drop-shadow(0 18px 32px rgba(255, 201, 60, 0.18));
  }

  &__bubble {
    position: relative;
    padding: 14px 22px;
    background: $p-point;
    color: $p-ink;
    border-radius: 14px;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.55;
    text-align: center;
    box-shadow: 0 8px 24px rgba(255, 201, 60, 0.25), 0 0 0 1px rgba(201, 138, 10, 0.4);

    &::after {
      content: '';
      position: absolute;
      top: -8px;
      left: 50%;
      transform: translateX(-50%) rotate(45deg);
      width: 14px;
      height: 14px;
      background: $p-point;
      box-shadow: -1px -1px 0 0 rgba(201, 138, 10, 0.4);
    }
  }

  // ── 우측 폼 ──
  &__right {
    display: grid;
    place-items: center;
    padding: 48px 32px;
    background: $p-bg;
    font-family: $p-font-body;
  }

  &__form-wrap {
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
  }

  &__chip {
    display: inline-flex;
    align-self: flex-start;
    padding: 5px 12px;
    background: $p-point-soft;
    color: $p-point-deep;
    font-family: $p-font-body;
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 0.16em;
    border-radius: 999px;
    margin-bottom: 14px;
  }

  &__title {
    margin: 0 0 8px;
    font-size: 36px;
    font-weight: 900;
    letter-spacing: -0.03em;
    color: $p-ink;
    line-height: 1.15;
  }

  &__desc {
    margin: 0 0 28px;
    font-size: 13px;
    color: $p-ink-mid;
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  &__input {
    height: 48px;
    padding: 0 16px;
    font-size: 14px;
    background: $p-panel;
    border: 1px solid $p-line;
    border-radius: 10px;

    &:focus {
      border-color: $p-point-deep;
      box-shadow: 0 0 0 3px $p-point-glow;
    }
  }

  &__btn {
    margin-top: 6px;
    height: 52px;
    border: 0;
    border-radius: 10px;
    background: $p-ink;
    color: $p-panel;
    font-family: $p-font-body;
    font-size: 15px;
    font-weight: 800;
    cursor: pointer;
    transition: background $p-dur $p-ease, transform $p-dur $p-ease;

    &:hover {
      background: lighten($p-ink, 8%);
    }

    &:active {
      transform: translateY(1px);
    }
  }

  &__foot {
    margin-top: 56px;
    padding-top: 18px;
    border-top: 1px solid $p-line;
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 12px;
    color: $p-ink-mid;
    font-weight: 600;
  }

  &__copyright {
    margin: 0;
    text-align: center;
    font-size: 12px;
    color: $p-ink-mid;
    font-weight: 600;
    letter-spacing: 0.01em;
  }
}

// p-field label 오버라이드 — 라이브 디자인에 맞춰 더 큰 라벨
.signin :deep(.p-field__label) {
  font-size: 13px;
  font-weight: 700;
  color: $p-ink;
  text-transform: none;
  letter-spacing: 0;
  margin-bottom: 8px;
}
</style>
